import en from "./en.json";
import ru from "./ru.json";
import es from "./es.json";
import uk from "./uk.json";
import pl from "./pl.json";
import de from "./de.json";
import fr from "./fr.json";
import ro from "./ro.json";
import hu from "./hu.json";

export type Localizations = typeof en;

const localizations: Record<string, Localizations> = {
  EN: en,
  RU: ru as unknown as Localizations,
  ES: es as unknown as Localizations,
  UK: uk as unknown as Localizations,
  PL: pl as unknown as Localizations,
  DE: de as unknown as Localizations,
  FR: fr as unknown as Localizations,
  RO: ro as unknown as Localizations,
  HU: hu as unknown as Localizations,
};

export default localizations;
